import React, { useRef, useState } from "react";
import { PaystackConsumer } from "react-paystack";
import { postDotNetDataWithKey } from "../../../../apis/apiMethods";
import { apiEndpoints } from "../../../../apis/apiEndpoints";
import { paystackConfig } from "../../../../helpers/thirdPartyConfig";
import { useHistory } from "react-router-dom";
import { message } from "antd";
import { errorHandler, errorToast } from "../../../../helpers/errorHandler";
import {appInsights} from "../../../AppInsight/AppInsight";

const AddCard = ({
  walletDetails,
  wallet,
  email,
  updatePayStackStatus,
  fetchWallet,
  fetchAddedCards,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const paystackRef = useRef();
  const openPaystackWidget = () => {
    paystackRef?.current?.click();
  };

  const onPaystackSuccess = async (data) => {
    setIsLoading(true);
    try {
      await postDotNetDataWithKey(
        apiEndpoints.addCard,
        {
          aggregator_id: wallet.aggregator_id,
          borrower_id: walletDetails?.customerId,
          paystack_reference: data?.reference,
          paystack_transaction: data?.trans,
        },
        wallet?.encryptedKey
      );
      fetchWallet();
      fetchAddedCards();
    } catch (error) {
      errorToast(errorHandler(error));
        appInsights.trackException({
            exception: error,
            properties: {fileName : AddCard}
        })
    }
    setIsLoading(false);
  };

  const onPaystackClose = () => {
    setIsLoading(false);
    // window.location.reload();
  };

  const paystackComponentProps = {
    ...paystackConfig({
      email: email,
      amount: 5000, // 50 naira is 5000 kobo
    }),
    onSuccess: (reference) => {
      onPaystackSuccess(reference);
    },
    onClose: onPaystackClose,
  };
  return (
    <div>
      <button
        disabled={isLoading}
        className="btn btn-primary"
        onClick={() => {
          updatePayStackStatus();
          openPaystackWidget();
        }}
      >
        {isLoading ? (
          <span className="spinner-border text-white" />
        ) : (
          "Add Card"
        )}
      </button>

      <PaystackConsumer {...paystackComponentProps}>
        {({ initializePayment }) => (
          <button
            ref={paystackRef}
            onClick={() => {
              setIsLoading(true);
              initializePayment(onPaystackSuccess, onPaystackClose);
            }}
            className="d-none"
          />
        )}
      </PaystackConsumer>
    </div>
  );
};

export default AddCard;
